import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const ProtectedRoute = ({ children }) => {
	const { isAuthenticated, setRequestedPath } = useAuth();
	const location = useLocation();

	if (!isAuthenticated) {
		//Mentjük a kért útvonalat
		const currentPath = `${location.pathname}${location.search}`;
		setRequestedPath(currentPath);
		return <Navigate to="/" />;
	}

	return children;
};

export default ProtectedRoute;
